import React from 'react'
import { useUpdateEventUserMutation } from '../../api/eventUser.api'
import FormBuilder from '../../components/FormBuilder'
import { useMyContext } from '../../context/context'
import useSettingsV2 from '../../hooks/useSettingsV2'
import HTML from '../../components/HTML'
import { useSteps } from './Steps'

const Informations3 = () => {
  const { myContext, userId: myUserId, user } = useMyContext()
  const { nextStep, userId, setUserId, NextButton } = useSteps()
  const { settings: settingsV2 } = useSettingsV2()

  const [updateEventUser] = useUpdateEventUserMutation()

  return (
    <div>
      <HTML name="FO_MEETING_INFO_3_HTML" />
      <FormBuilder
        formIdDefault={settingsV2?.FO_MEETING_INFORMATIONS_3_FORM_ID}
        userId={userId || 0}
        onFinish={async u => {
          if (myUserId !== u?.id) {
            await updateEventUser({
              ...myContext,
              userId: u.id,
              eventUser: {
                registeredBy: `${user.firstName || ''} ${user.lastName || ''} (${user.id})`,
                isRemote: false,
                registeredFrom: localStorage.getItem('canal') || 'WEB',
              },
            })
          }
          setUserId(u.id)
          nextStep()
        }}
        Buttons={NextButton}
      />
    </div>
  )
}

export default Informations3
